<template>
    <div class="text-center" v-if="generating">
        <i class="icon-spinner6 spinner mr-2"></i>{{ $t('aiGeneration.loading.waitingForResponse') }}<span class="dots">.</span>
    </div>
    <template v-else>
        <div class="d-flex justify-content-end mb-2">
            <AppButton color="indigo" @click="generateSeo" :disabled="regenerating || (tokenBalance !== null && tokenBalance <= 0)">
                <i :class="['icon-sync mr-2', { 'spinner': regenerating }]"></i>
                {{ $t('aiGeneration.buttons.regenerate') }}
            </AppButton>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <FormGroup :label="`${$t('labels.seo')} (${ $t('aiGeneration.review.old') })`">
                    <Tags :model-value="product.seos[mainIntegrationLanguage]" disabled/>
                </FormGroup>
            </div>
            <div class="col-lg-6">
                <FormGroup :label="`${$t('labels.seo')} (${ $t('aiGeneration.review.new') })`" >
                    <Tags :model-value="generatedSeo" @update:model-value="$emit('update:generated-seo', $event)"/>
                </FormGroup>
            </div>
        </div>
    </template>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Tags from '../../../../../components/new/form/Tags.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

import GeminiService from '../../../../../services/GeminiService/GeminiService';
import MessageNotificator from '../../../../../services/MessageNotificator';
import { TooManyRequestsError } from '../../../../../services/Errors/TooManyRequestsError';
import { ServiceUnavailableError } from '../../../../../services/Errors/ServiceUnavailableError';
import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: 'SeoScreen',
    components: {
        FormGroup, Tags, AppButton
    },
    props: {
        generatedSeo: {
            type: String,
            default: ''
        },
        product: {
            type: Object,
            required: true
        },
        geminiService: {
            type: GeminiService,
            required: true
        },
        mainIntegrationLanguage: {
            type: String,
            default: 'en'
        },
        names: {
            type: String,
            default: null
        },
        integrationService: {
            type: String,
            default: null
        },
        formattedFilters: {
            type: Array,
            default: () => []
        },
        tokenBalance: {
            type: [Number, null],
            default: null
        }
    },
    emits: ['generatingStarted', 'generatingStopped', 'update:generated-seo'],
    data() {
        return {
            generating: true,
            regenerating: false,
            prompts: {}
        }
    },
    methods: {
        async generateSeo() {
            this.regenerating = true;
            this.$emit('generatingStarted');
            const prompt = this.createPrompt();

            try {
                const response = await this.geminiService.generateString(prompt, {
                    temperature: 0.2,
                    topP: 0.95,
                    maxOutputTokens: 500
                });
                let generatedSeo = response
                    .split(',')
                    .map(item => item.trim())
                    .map(item => item.split(' ').join(' '))
                    .join(', ');

                this.$emit('update:generated-seo', generatedSeo);
            } catch (error) {
                if (error instanceof TooManyRequestsError) {
                    new MessageNotificator().warning(this.$t('alerts.too_many_requests'));
                } else if (error instanceof ServiceUnavailableError) {
                    new MessageNotificator().error(this.$t('alerts.service_unavailable'));
                } else {
                    new MessageNotificator().error(this.$t('alerts.contact_support'));
                }
                return;
            } finally {
                await this.geminiService.flushTokens(this.$route.params.projectUuid, `Генерація ключових слів для товару ${this.product.names[this.mainIntegrationLanguage] || Object.values(this.product.names)[0] || ''}`);
                this.$emit('tokensFlushed');
            }

            this.regenerating = false;
            this.generating = false;
            this.$emit('generatingStopped');
        },
        createPrompt() {
            let prompt = this.prompts[this.integrationService] || this.prompts.default;

            let parametersForGeneration = `
                Product details:
                Name: ${this.names ? JSON.stringify(this.names) :  "Not specified"}
                Filters: ${JSON.stringify(this.formattedFilters)}

                Translation language: ${this.mainIntegrationLanguage}

                Return queries separated by commas, without any additional text.
            `;

            return prompt + parametersForGeneration;
        },
        async fetchPrompts() {
            const response = await httpClient.post(`/proxy/http-request`, {
                method: "GET",
                url: "https://fasunok.s3.eu-west-2.amazonaws.com/system/gemini-prompts/seo.json"
            });
;
            if (response.status === 200) {
                this.prompts = response.data;
            }
        }
    },
    async mounted() {
        await this.fetchPrompts();
        await this.generateSeo();
    }
}
</script>